import React from 'react';
import withRouter from '../../Components/Common/withRouter';

const ParticlesAuth = ({ children }) => {
  return (
    <React.Fragment>
      <div
        className="auth-page-wrapper"
        style={{
          backgroundColor: "#000",        // Set dark background
          minHeight: "100vh",             // Full viewport height
          color: "#fff",                  // Light text color (optional)
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between" // So footer stays at bottom
        }}
      >
        {/* Content */}
        <div>{children}</div>

        {/* Footer */}
        <footer className="footer">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-center">
                  <p className="mb-0 text-muted">
                    &copy; {new Date().getFullYear()} Risknox. Crafted with{" "}
                    <i className="mdi mdi-heart text-danger"></i>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
